import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bcf034a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "box",
  id: "paramCulture"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, " Paramètres de la culture ", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "lane" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lieu" }, "Commune (Vienne et Deux-Sèvres)", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "anneeRecolte" }, "Année de récolte", -1))
const _hoisted_7 = { class: "lane" }
const _hoisted_8 = { class: "subbox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lane" }, " Données culture ", -1))
const _hoisted_10 = { class: "lane" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "espece" }, "Espèce", -1))
const _hoisted_12 = { class: "lane" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "rendementMax" }, "Rendement maximum génétique (q/ha)", -1))
const _hoisted_14 = { class: "lane" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pmgMax" }, "PMG maximum génétique (g)", -1))
const _hoisted_16 = { class: "lane" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tempMax" }, "Temperature maximale plant (°C)", -1))
const _hoisted_18 = { class: "lane" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tempOptimale" }, "Temperature optimale plant (°C)", -1))
const _hoisted_20 = { class: "subbox" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lane" }, " Données sol ", -1))
const _hoisted_22 = {
  class: "lane",
  style: {"height":"200px","align-items":"center"}
}
const _hoisted_23 = { for: "epSol" }
const _hoisted_24 = {
  class: "lane",
  style: {"height":"150px","align-items":"center"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "reserveUtileEau" }, "Réserve utile en eau Maximum (mm)", -1))
const _hoisted_26 = {
  class: "box",
  id: "projectionTheorique"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, " Développement de la plante ", -1))
const _hoisted_28 = { class: "content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lane" }, " Evolution potentielle de la biomasse ", -1))
const _hoisted_30 = { class: "lane" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lane" }, " Rendement potentiel (Qt/ha) ", -1))
const _hoisted_32 = { class: "lane" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lane" }, " Risque climatique ", -1))
const _hoisted_34 = { class: "lane" }
const _hoisted_35 = {
  class: "box",
  id: "paramScenario"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, " Simulation des aléas climatiques ", -1))
const _hoisted_37 = { class: "content" }
const _hoisted_38 = {
  class: "lane",
  style: {"justify-content":"center"}
}
const _hoisted_39 = { class: "lane" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lane" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Edition aléa")
], -1))
const _hoisted_41 = { class: "lane" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "aleaIntensity" }, "Intensité", -1))
const _hoisted_43 = { class: "lane" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lane" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Période")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"large"} }, "Aléas", -1))
const _hoisted_46 = { class: "subbox" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  class: "box",
  id: "simulationScenario"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, " Evolution de la biomasse ", -1))
const _hoisted_50 = { class: "content" }
const _hoisted_51 = { class: "lane" }
const _hoisted_52 = { class: "lane" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_slider = _resolveComponent("va-slider")!
  const _component_TimeserieLinearGraph = _resolveComponent("TimeserieLinearGraph")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_option_list = _resolveComponent("va-option-list")!
  const _component_va_date_picker = _resolveComponent("va-date-picker")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_list_label = _resolveComponent("va-list-label")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_list_item_section = _resolveComponent("va-list-item-section")!
  const _component_va_list_item_label = _resolveComponent("va-list-item-label")!
  const _component_va_list_item = _resolveComponent("va-list-item")!
  const _component_va_list = _resolveComponent("va-list")!
  const _component_gauge_ratio = _resolveComponent("gauge-ratio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_va_divider, { class: "header-underline" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createVNode(_component_va_select, {
              id: "lieu",
              onUpdateSearch: _ctx.searchOptionsLieux,
              options: _ctx.optionsLieux,
              modelValue: _ctx.formValues.lieu,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValues.lieu) = $event)),
              "no-options-text": "Pas de correspondance trouvée",
              searchable: ""
            }, null, 8, ["onUpdateSearch", "options", "modelValue"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _createVNode(_component_va_input, {
              modelValue: _ctx.formValues.annee,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValues.annee) = $event)),
              id: "anneeRecolte",
              type: "number"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_va_divider, { class: "header-underline" }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _createVNode(_component_va_input, {
                  modelValue: _ctx.formValues.espece,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formValues.espece) = $event)),
                  id: "espece",
                  placeholder: "Blé"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _hoisted_13,
                _createVNode(_component_va_input, {
                  modelValue: _ctx.formValues.rendementMax,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formValues.rendementMax) = $event)),
                  type: "number",
                  id: "rendementMax",
                  placeholder: "120"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _hoisted_15,
                _createVNode(_component_va_input, {
                  modelValue: _ctx.formValues.pmgMax,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formValues.pmgMax) = $event)),
                  type: "number",
                  class: "m-4",
                  id: "pmgMax",
                  placeholder: "42"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _hoisted_17,
                _createVNode(_component_va_slider, {
                  modelValue: _ctx.formValues.tempMax,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formValues.tempMax) = $event)),
                  color: "#e34a4a",
                  min: _ctx.configRanges.tempMax.min,
                  max: _ctx.configRanges.tempMax.max,
                  "track-label-visible": ""
                }, null, 8, ["modelValue", "min", "max"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _hoisted_19,
                _createVNode(_component_va_slider, {
                  modelValue: _ctx.formValues.tempOptimale,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formValues.tempOptimale) = $event)),
                  color: "warning",
                  min: _ctx.configRanges.tempOptimale.min,
                  max: _ctx.configRanges.tempOptimale.max,
                  "track-label-visible": ""
                }, null, 8, ["modelValue", "min", "max"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_va_divider, { class: "header-underline" }),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, "Epaisseur de sol C0 (mm) - min:" + _toDisplayString(_ctx.configRanges.epSol.min) + " - max:" + _toDisplayString(_ctx.configRanges.epSol.max), 1),
              _createVNode(_component_va_slider, {
                modelValue: _ctx.formValues.epSol,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formValues.epSol) = $event)),
                vertical: "",
                color: "#976318",
                heigth: "1000px",
                min: _ctx.configRanges.epSol.min,
                max: _ctx.configRanges.epSol.max,
                "track-label-visible": ""
              }, null, 8, ["modelValue", "min", "max"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_va_slider, {
                modelValue: _ctx.formValues.reserveUtileEau,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formValues.reserveUtileEau) = $event)),
                vertical: "",
                color: "#181C97",
                min: _ctx.configRanges.reserveUtileEau.min,
                max: _ctx.configRanges.reserveUtileEau.max,
                "track-label-visible": ""
              }, null, 8, ["modelValue", "min", "max"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createVNode(_component_va_divider, { class: "header-underline" }),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          (_ctx.matiereSecheSimulationTheorique.length >= 2)
            ? (_openBlock(), _createBlock(_component_TimeserieLinearGraph, {
                key: 0,
                data: _ctx.matiereSecheSimulationTheorique,
                id: "matiereSeche",
                "x-name": _ctx.date,
                zoom: false,
                yAxis: {label:{text: 'Matière sèche (g/cm2)',position: 'outer-center'}}
              }, null, 8, ["data", "x-name", "yAxis"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          (_ctx.rendementSimulationTheorique.length >= 2)
            ? (_openBlock(), _createBlock(_component_TimeserieLinearGraph, {
                key: 0,
                data: _ctx.rendementSimulationTheorique,
                id: "rendement",
                "x-name": _ctx.date,
                zoom: false,
                yAxis: {label:{text: '(Qt/ha)',position: 'outer-center'}}
              }, null, 8, ["data", "x-name", "yAxis"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          (_ctx.eauSecheresseProbaAlea.length >= 2)
            ? (_openBlock(), _createBlock(_component_TimeserieLinearGraph, {
                key: 0,
                data: _ctx.eauSecheresseProbaAlea,
                id: "probaAlea",
                "x-name": _ctx.date,
                grid: {y: {lines: [{value: '0.42' , text: 'Seuil de confiance'}]}},
                yAxis: {label:{text: 'Probabilité',position: 'outer-center'}}
              }, null, 8, ["data", "x-name", "grid"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createVNode(_component_va_divider, { class: "header-underline" }),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_va_button, {
            disabled: true,
            icon: "remove_circle_outline"
          }),
          _createVNode(_component_va_button_group, {
            style: {"margin-left":"15px","margin-right":"15px"},
            outline: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, (scenari) => {
                return (_openBlock(), _createBlock(_component_va_button, {
                  onClick: ($event: any) => (_ctx.formValues.selectedScenario = scenari)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scenari.nom), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 256))
            ]),
            _: 1
          }),
          _createVNode(_component_va_button, {
            disabled: true,
            icon: "add_circle_outline"
          })
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", null, [
            _createVNode(_component_va_list, null, {
              default: _withCtx(() => [
                (_ctx.selectedAlea)
                  ? (_openBlock(), _createBlock(_component_va_modal, {
                      key: 0,
                      modelValue: _ctx.selectedAlea,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedAlea) = $event)),
                      "hide-default-actions": ""
                    }, {
                      header: _withCtx(() => [
                        _hoisted_40,
                        _createVNode(_component_va_divider, { class: "header-underline" })
                      ]),
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default", {}, () => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_va_option_list, {
                              id: "aleaType",
                              type: "radio",
                              options: _ctx.aleaTypes,
                              modelValue: _ctx.selectedAlea.type,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedAlea.type) = $event))
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createVNode(_component_va_slider, {
                              id: "aleaIntensity",
                              label: _ctx.intensiteTypes[_ctx.selectedAlea.intensite].label,
                              "label-color": _ctx.intensiteTypes[_ctx.selectedAlea.intensite].color,
                              color: _ctx.intensiteTypes[_ctx.selectedAlea.intensite].color,
                              modelValue: _ctx.selectedAlea.intensite,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedAlea.intensite) = $event)),
                              min: "0",
                              max: "2"
                            }, null, 8, ["label", "label-color", "color", "modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", null, [
                              _hoisted_44,
                              _createVNode(_component_va_date_picker, {
                                id: "periode",
                                "start-year": _ctx.formValues.annee,
                                "end-year": _ctx.formValues.annee+1,
                                mode: "range",
                                view: _ctx.datePickerMonthView,
                                "onUpdate:view": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.datePickerMonthView) = $event)),
                                modelValue: _ctx.selectedAlea.periode,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedAlea.periode) = $event))
                              }, null, 8, ["start-year", "end-year", "view", "modelValue"])
                            ])
                          ])
                        ], true)
                      ]),
                      _: 3
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_va_list_label, null, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_46, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValues.selectedScenario.aleas, (alea, aleaIndex) => {
                    return (_openBlock(), _createBlock(_component_va_list_item, { key: aleaIndex }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_list_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_icon, {
                              name: _ctx.aleaIcones[alea.type].icon,
                              color: _ctx.aleaIcones[alea.type].color
                            }, null, 8, ["name", "color"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_va_list_item_section, {
                          onClick: ($event: any) => (_ctx.selectedAlea = alea)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_list_item_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(alea.type), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_va_list_item_label, { caption: "" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.dateService.formatToRelativeFrLocalDate(alea?.periode?.start)), 1),
                                (alea?.periode?.end)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, " - " + _toDisplayString(_ctx.dateService.formatToRelativeFrLocalDate(alea.periode?.end)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_va_list_item_section, { icon: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_icon, {
                              onClick: ($event: any) => (_ctx.formValues.selectedScenario.aleas.splice(aleaIndex, 1)),
                              name: "remove_circle_outline",
                              color: "danger"
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_va_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_list_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_list_item_label, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_va_button, {
                                icon: "add_circle_outline",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.pushAlea(_ctx.formValues.selectedScenario)))
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 3
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _hoisted_49,
      _createVNode(_component_va_divider, { class: "header-underline" }),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          (_ctx.matiereSecheSimulationScenarioPlusTheorique.length >= 3)
            ? (_openBlock(), _createBlock(_component_TimeserieLinearGraph, {
                key: 0,
                data: _ctx.matiereSecheSimulationScenarioPlusTheorique,
                id: "matiereSecheSimulation",
                "x-name": _ctx.date,
                grid: _ctx.gridMatiereSecheSimulationScenarioPlusTheorique,
                regions: _ctx.regionsMatiereSecheSimulationScenarioPlusTheorique,
                zoom: false,
                "force-full-reload": true
              }, null, 8, ["data", "x-name", "grid", "regions"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_52, [
          (_ctx.maxRendementSimulationScenario != 0 && _ctx.maxRendementSimulationTheorique != 0)
            ? (_openBlock(), _createBlock(_component_gauge_ratio, {
                key: 0,
                actual: _ctx.maxRendementSimulationScenario,
                expected: _ctx.maxRendementSimulationTheorique
              }, null, 8, ["actual", "expected"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}